import { PayStubI } from "views/applications-id-report/utils/PayStub";
import { DocumentCard } from "../../DocumentCard";
import { UniversalExpanderDataColumn } from "../../UniversalExpanderDataColumn";
import { UniversalSubTable } from "../../UniversalSubTable";
import { PayDistributionColumns } from "../columns/PayDistributionColumns";
import { ColumnDef } from "@tanstack/react-table";
import { EarningColumns } from "../columns/EarningColumns";
import { DeductionColumns } from "../columns/DeductionColumns";
import { getPayStubsMappings } from "../utils";

type PayStubDetailsProps = {
  payStubs?: PayStubI[];
};

export const PayStubDetails = ({ payStubs }: PayStubDetailsProps) => {
  return payStubs?.map((el, idx) => {
    const payStubDetailsData = getPayStubsMappings(el);

    return (
      <div key={el.uuid} className="flex flex-col gap-3">
        <div className="mt-3 border-b border-alpha-100">
          <p className="w-fit border-b-2 border-content-1000 text-content-1000 font-medium text-sm pb-2">
            Paystub {idx + 1}
          </p>
        </div>

        <div className="mb-6">
          <DocumentCard
            score={
              el.doc_analysis.form_analysis[0]?.form_authenticity?.score || 0
            }
            asset={el.asset?.asset}
            reason_codes={
              el.doc_analysis.form_analysis[0]?.form_authenticity?.reason_codes
            }
          />
        </div>

        <UniversalExpanderDataColumn
          title="Paystub details"
          data={payStubDetailsData.payStubsDetailsMappings}
        />
        <UniversalExpanderDataColumn
          title="Employer information"
          data={payStubDetailsData.employerInformationMappings}
        />

        <UniversalExpanderDataColumn
          title="Employee information"
          data={payStubDetailsData.employeeInformationMappings}
        />

        <UniversalSubTable
          tableData={el.pay_distribution}
          tableColumns={PayDistributionColumns as ColumnDef<unknown, any>[]}
        />

        <UniversalSubTable
          tableData={el.earnings.totals}
          tableColumns={EarningColumns as ColumnDef<unknown, any>[]}
        />

        <UniversalSubTable
          tableData={el.deductions.subtotals}
          tableColumns={DeductionColumns as ColumnDef<unknown, any>[]}
        />
      </div>
    );
  });
};
